var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import Input from './input.js';
export const PasswordInput = (_a) => {
    var { isPasswordShown, passwordStrengthScore, requiredPasswordScore, className } = _a, props = __rest(_a, ["isPasswordShown", "passwordStrengthScore", "requiredPasswordScore", "className"]);
    const [isPasswordShownState, setIsPasswordShownState] = useState(isPasswordShown);
    const handleToggleShowPassword = () => {
        setIsPasswordShownState((isPasswordShownState) => !isPasswordShownState);
    };
    return (_jsx(Input, Object.assign({ className: className, helperText: `${isPasswordShownState ? 'Hide' : 'Show'} password`, helperLinkAction: handleToggleShowPassword, type: isPasswordShownState ? 'text' : 'password', passwordStrengthScore: passwordStrengthScore, requiredPasswordScore: requiredPasswordScore }, props)));
};
const StyledPasswordInput = styled(PasswordInput).withConfig({ displayName: "brc-StyledPasswordInput", componentId: "brc-1xownp0" }) ``;
export default StyledPasswordInput;
//# sourceMappingURL=password-input.js.map